module.exports = __webpack_public_path__ + "static/media/galery-1.d885156a.png";